/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventoPatchFieldsEnum } from './eventoPatchFieldsEnum';
import { TextSupportedContentType } from './textSupportedContentType';
import { EventoFields } from './eventoFields';
import { EventoPatchAllOf } from './eventoPatchAllOf';


/**
 * Solicitud de Path del Perfil Empresarial
 */
export interface EventoPatch { 
    /**
     * Define el titulo del evento.
     */
    titulo?: string;
    /**
     * Informacion del evento.
     */
    info?: string;
    /**
     * Itinerario del evento.
     */
    itinerario?: string;
    /**
     * Que incluye
     */
    incluye?: string;
    /**
     * Que no incluye
     */
    noIncluye?: string;
    /**
     * Recomendaciones
     */
    recomendaciones?: string;
    /**
     * Termino y condiciones
     */
    terminoCondiciones?: string;
    /**
     * Devoluciones y reembolso
     */
    devoluciones?: string;
    formatText?: TextSupportedContentType;
    /**
     * Fecha de comienzo del evento.
     */
    fecha?: Date;
    /**
     * Fecha de finalizacion del evento.
     */
    finalizacion?: Date;
    /**
     * Especifica el costo del evento. En pesos.
     */
    valor?: number;
    /**
     * Especifica la capacidad del evento.
     */
    cupos?: number;
    /**
     * Especifica la categoria del evento. como un conjuntos de tags indexado.
     */
    categoria?: Array<string>;
    /**
     * Especifica el tipo del evento.
     */
    clasificacion?: EventoPatch.ClasificacionEnum;
    fields: Array<EventoPatchFieldsEnum>;
    /**
     * Especifica la cantidad de cupos.
     */
    incCupos?: number;
    publish?: boolean;
}
export namespace EventoPatch {
    export type ClasificacionEnum = 'EVENTO' | 'ACTIVIDAD';
    export const ClasificacionEnum = {
        EVENTO: 'EVENTO' as ClasificacionEnum,
        ACTIVIDAD: 'ACTIVIDAD' as ClasificacionEnum
    };
}


